import $ from 'jquery';
import datepicker from 'js-datepicker';

$(document).ready(function() {
  if ($('#calendar').length > 0) {
    initCalendar();
  }

  function initCalendar() {
    // calendar pick tab with articles
    let currentCalendarDate = {
      day: 0,
      month: 0,
      year: 0
    };

    const picker = datepicker('#calendar', {
      // Customizations.
      formatter: (input, date) => {
        input.value = date.toDateString();
      },

      position: 'c', // Top right.
      startDay: 1,
      customDays: ['вс', 'пн', 'вт', 'ср', 'чт', 'пт', 'сб'],
      customMonths: [
        'Січень',
        'Лютий',
        'Березень',
        'Квітень',
        'Травень',
        'Червень',
        'Липень',
        'Серпень',
        'Вересень',
        'Жовтень',
        'Листопад',
        'Грудень'
      ],
      overlayButton: 'Go!',
      overlayPlaceholder: 'Enter a 4-digit year',

      // Settings.
      alwaysShow: true,
      dateSelected: new Date(),
      maxDate: new Date(),
      minDate: new Date(2016, 5, 1),
      startDate: new Date(),
      showAllDates: true,
      noWeekends: false,
      disableMobile: false,
      disableYearOverlay: true,
      siblings: true,
      id: 1,

      onShow: instance => {
        currentCalendarDate.days = new Date(instance.dateSelected).getDay();
        currentCalendarDate.month = instance.currentMonth;
        currentCalendarDate.year = instance.currentYear;
      },

      onSelect: (instance, date) => {
        var day = date.getDate();
        var month = date.getMonth() + 1;
        var year = date.getFullYear();
        if (day < '10') {
          var day = '0' + day;
        }
        if (month < '10') {
          var month = '0' + month;
        }
        var output = year + '-' + month + '-' + day;

        window.location.href = `/novyny/?date=${output}`;
        picker.setDate(new Date(year, month, day), true);
      }
    });

    let clickedDate = window.location.search
      .replace('?', '')
      .split('&')
      .reduce(function(p, e) {
        var a = e.split('=');
        p[decodeURIComponent(a[0])] = decodeURIComponent(a[1]);
        return p;
      }, {});

    if (typeof clickedDate['date'] !== 'undefined') {
      picker.setDate(new Date(clickedDate['date']), true);
    }

    //calendar year pick date
    $('.calendar__date-link').on('click', function(e) {
      e.preventDefault();

      let years = parseInt($(this).attr('data-tab'));

      picker.setDate(new Date(years, currentCalendarDate.month, 1), true);

      $('.calendar__date-link').removeClass('date-current');

      $(this).addClass('date-current');
    });
  }

  // mobile version calendar

  $('.menu-nav-mob__link').click(function() {
    $(this)
      .find('.icon-secondary-nav__vector-down')
      .toggleClass('vector-active');
    $('.calendar__wrapper')
      .fadeToggle()
      .toggleClass('calendar-show');
  });
});
